import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import { Box, Container, Tab, Tabs, Typography } from '@mui/material';
import React, { useState } from 'react';
import styled from 'styled-components';
import DeliveryForm from './DeliveryForm';
import AdminDeliveryForm from './AdminDeliveryForm';
import DeliveriesHistory from './DeliveriesHistory';
import { isAdmin } from '../../../config/roles';
import useIndex from '../../../hooks/useIndex';

const MoveDeliveriesPage = () => {
    const { auth } = useIndex();
    const admin = isAdmin(auth);
    const [tab, setTab] = useState(0);
    // Cuando se completa una entrega el form notifica para que el
    // historial se refresque al cambiar de tab. Como ambos tabs viven
    // en el mismo árbol y montan/desmontan, usamos un nonce que el
    // historial observa para refetchear.
    const [refreshKey, setRefreshKey] = useState(0);

    return (
        <PageContainer maxWidth={false}>
            <PageHeader>
                <Box className="title-wrap">
                    <Box className="icon-box">
                        <HandshakeOutlinedIcon />
                    </Box>
                    <Box>
                        <Typography className="title">Entregar jugadas</Typography>
                        <Typography className="subtitle">
                            {admin
                                ? 'Entrega jugadas a cualquier usuario (jugadores y distribuidores).'
                                : 'Asigna jugadas a un Jugador por su cédula o generando un QR.'}
                        </Typography>
                    </Box>
                </Box>
            </PageHeader>

            <StyledTabs value={tab} onChange={(_e, v) => setTab(v)}>
                <Tab label="Entregar" />
                <Tab label="Historial" />
            </StyledTabs>

            <Box mt={1.5}>
                {tab === 0 && (
                    admin
                        ? <AdminDeliveryForm onDelivered={() => setRefreshKey((k) => k + 1)} />
                        : <DeliveryForm onDelivered={() => setRefreshKey((k) => k + 1)} />
                )}
                {tab === 1 && (
                    <DeliveriesHistory refreshKey={refreshKey} />
                )}
            </Box>
        </PageContainer>
    );
};

export default MoveDeliveriesPage;

const PageContainer = styled(Container)`
    padding: 0.8rem !important;
`;

const PageHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 0.8rem;

    .title-wrap {
        display: flex;
        align-items: center;
        gap: 0.7rem;
    }

    .icon-box {
        width: 42px;
        height: 42px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #10285f;
        background: rgba(214, 170, 58, 0.16);
        border: 1px solid rgba(214, 170, 58, 0.28);
    }

    .title {
        color: #10285f;
        font-size: 1.2rem;
        font-weight: 900;
        line-height: 1.1;
    }

    .subtitle {
        color: rgba(15, 34, 77, 0.62);
        font-size: 0.82rem;
        font-weight: 600;
        margin-top: 0.1rem;
    }
`;

const StyledTabs = styled(Tabs)`
    border-bottom: 1px solid rgba(15, 34, 77, 0.1);
    min-height: 38px !important;

    .MuiTab-root {
        text-transform: uppercase;
        font-weight: 800;
        letter-spacing: 0.4px;
        font-size: 0.78rem;
        color: rgba(15, 34, 77, 0.62);
        min-height: 38px !important;
        padding: 0.4rem 1rem !important;

        &.Mui-selected {
            color: #10285f;
        }
    }

    .MuiTabs-indicator {
        background-color: #d6aa3a;
        height: 3px;
        border-radius: 3px 3px 0 0;
    }
`;
